/* Editorial navigation uses the existing native purchase controls; it owns no cart state. */
(() => {
  if (window.SofthourEditorial) return;
  window.SofthourEditorial = true;
  document.addEventListener('click', event => {
    const unit = event.target.closest('[data-sp-sizes] button[data-sp-unit]');
    if (unit) {
      const section = unit.closest('[data-sp-sizes]');
      section.dataset.spUnit = unit.dataset.spUnit;
      section.querySelectorAll('button[data-sp-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
      return;
    }
    const link = event.target.closest('a[data-sp-choose-size]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
    const product = document.querySelector('[data-sf-product].is-enhanced');
    if (!product) return;
    const value = link.dataset.spChooseSize;
    const control = [...product.querySelectorAll('select[data-sf-option-index],input[data-sf-option-index]')].find(input => input.tagName === 'SELECT' ? [...input.options].some(option => option.value === value) : input.value === value);
    if (!control || control.disabled) return;
    event.preventDefault();
    if (control.type === 'radio') control.checked = true;
    else control.value = value;
    control.dispatchEvent(new Event('change', { bubbles: true }));
    const destination = control.closest('.sh-gp-option') || control;
    destination.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    control.focus({ preventScroll: true });
  });
})();
